import React from "react";
import { Button, HStack, Modal, Placeholder } from "rsuite";
import styles from "./WithdrawModal.module.scss";
import { FaCheck } from "react-icons/fa6";

export default function WithdrawModal() {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);

  const handleClose = () => setOpen(false);

  return (
    <>
      <Button appearance="primary" onClick={handleOpen}>
        Withdraw Money
      </Button>

      <Modal open={open} onClose={handleClose} size="29rem">
        <Modal.Body>
          <div className={styles.modal__body}>
            <img src="/images/wallet.png" alt="" />
            <h3>Complete your Basic verification to receive your referral earnings.</h3>

            <div className={styles.progress}>
              <HStack justifyContent="space-between">
                <div className={styles.item}>
                  <div className={styles.circle}>
                    <FaCheck color="#ffffff" size={15} />
                  </div>
                  <p>PAN Verification</p>
                </div>

                <div className={styles.item}>
                  <div className={`${styles.circle} ${styles.step2}`}></div>
                  <p>KYC Verification</p>
                </div>

                <div className={styles.item}>
                  <div className={`${styles.circle} ${styles.step3}`}></div>
                  <p>Penny Drop</p>
                </div>
              </HStack>
            </div>

            <Button block appearance="primary" onClick={handleOpen}>
              Continue to Withdraw
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
